// Live map data (city_explorer_data_routes.py) behind React/Leaflet map
// components (frontend/src/components/city_explorer/maps/) for locations whose
// maps read live from the `city_explorer` database instead of pre-baked
// Folium HTML.
//
// `get(locationId, endpoint, params)` does the request: logged-in users go
// through the authenticated API, share-link viewers through the share's
// public data route. `cacheKey` keeps their tab-level caches apart.
export function createLiveDataClient(cacheKey, get) {
  return {
    cacheKey,

    getDistrictGeoJson: (locationId) => get(locationId, 'districts.geojson'),

    getCountyGeoJson: (locationId) => get(locationId, 'counties.geojson'),

    getStateBoundary: (locationId) => get(locationId, 'state-boundary.geojson'),

    getRiskCalculatorData: (locationId) => get(locationId, 'risk-calculator'),

    getCharterSchools: (locationId) => get(locationId, 'charter-schools'),

    getRegionGeoJson: (locationId, regionType = 'ward') =>
      get(locationId, 'regions.geojson', { regionType }),

    getTravelRings: (locationId, sector, gradeBand) =>
      get(locationId, 'travel-rings.geojson', { sector, gradeBand }),

    // `sector` (all / district / charter / open_charter), `schoolAge`
    // (all / steady / new) and `travelMinutes` (a ring size the state has
    // loaded) are statewide filters; Newark omits them.
    getDeserts: (locationId, kind, gradeBand, qualityMode = 'either', { sector, schoolAge, travelMinutes } = {}) =>
      get(locationId, 'deserts.geojson', { kind, gradeBand, qualityMode, sector, schoolAge, travelMinutes }),

    getOverlap: (locationId, gradeBand, { kind, sector, schoolAge, travelMinutes } = {}) =>
      get(locationId, 'overlap.geojson', { gradeBand, kind, sector, schoolAge, travelMinutes }),

    getLiveSchools: (locationId, { sector, gradeBand } = {}) =>
      get(locationId, 'schools', { sector, gradeBand }),

    getPrek: (locationId) => get(locationId, 'prek'),

    getMapMeta: (locationId) => get(locationId, 'meta'),

    // Statewide headline numbers for the location landing page. Share links
    // never get this one (the backend refuses it).
    getLocationSummary: (locationId) => get(locationId, 'summary'),
  };
}
